module.exports = __webpack_public_path__ + "img/html.5a68a00a.svg";